import React, { useState } from 'react';
import styled from 'styled-components';

const PaymentContainer = styled.div`
  background: linear-gradient(145deg, #161a21 0%, #1e242e 100%);
  border-radius: var(--border-radius);
  padding: 32px;
  box-shadow: var(--shadow);
  border: 1px solid rgba(255, 255, 255, 0.05);
  max-width: 480px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  z-index: 2;

  &::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle at center, rgba(0, 212, 255, 0.1) 0%, transparent 70%);
    z-index: -1;
  }
`;

const Title = styled.h3`
  color: var(--lighter);
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 24px 0;
  text-align: center;
  letter-spacing: -0.01em;
`;

const Select = styled.select`
  width: 100%;
  padding: 14px 16px;
  margin-bottom: 16px;
  border-radius: var(--border-radius);
  background: #000000;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 1rem;
  font-weight: 500;
  appearance: none;
  transition: var(--transition);
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(0, 212, 255, 0.2);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  option {
    background: #000000;
    color: #ffffff;
  }
`;

const Button = styled.button`
  width: 100%;
  padding: 16px;
  border-radius: var(--border-radius);
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  color: var(--darker);
  font-size: 1rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  transition: var(--transition);
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 212, 255, 0.3);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 212, 255, 0.4);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

const SecondaryButton = styled(Button)`
  background: #cccccc;
  color: #666666;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #bbbbbb;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
  }
`;

const ErrorMessage = styled.p`
  color: #dc3545;
  font-size: 0.9rem;
  margin-top: 8px;
  text-align: center;
`;

const PaymentSection = () => {
  const [service, setService] = useState({
    value: '🖱️🔻ModMedia Pro Website Building - $300',
    price: 300,
    name: 'Advertiser or Fan Subscribe- $5 (Pick Product)',
  });
  
  // Changed: card is now default
  const [paymentMethod, setPaymentMethod] = useState('card');

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const services = [
    { value: 'website',        price: 300, name: '🖱️🔻ModMedia Pro Website Building - $300' },
    { value: 'ad-design',      price: 10,  name: 'ModMedia Designs Your Ad & Publishes - $15' },
    { value: 'comic_pay',      price: 15,  name: 'Cryptographers EXILE Comic- Founders Edition - 12.99$' },
  ];

  const handleServiceChange = (e) => {
    const selected = services.find((s) => s.value === e.target.value);
    setService(selected);
    // Optional: you can decide whether to reset payment method when service changes
    // setPaymentMethod('card'); // ← uncomment if you want card always default
  };

  const handlePaymentMethodChange = (e) => {
    setPaymentMethod(e.target.value);
    setError('');
  };

  const handleProceed = async () => {
    setIsLoading(true);
    setError('');

    localStorage.setItem(
      'paymentDetails',
      JSON.stringify({
        service: service.value,
        serviceName: service.name,
        amount: service.price,
        method: paymentMethod,
      })
    );

    window.location.href = '/checkout';
    // Note: setIsLoading(false) won't run because of redirect
    // You can remove this line or handle it differently if using router
  };

  return (
    <PaymentContainer>
      <Title>Our Digital Products Checkout:</Title>

      <Select onChange={handleServiceChange} value={service.value}>
        {services.map((s) => (
          <option key={s.value} value={s.value}>
            {s.name}
          </option>
        ))}
      </Select>

      {/* Changed layout: card is now default + crypto in dropdown */}
      <Select onChange={handlePaymentMethodChange} value={paymentMethod}>
        <option value="card">Pay with Credit / Debit Card</option>
        <option value="crypto">Pay with Crypto</option>
      </Select>

      {error && <ErrorMessage>{error}</ErrorMessage>}

      <Button onClick={handleProceed} disabled={isLoading}>
        {isLoading
          ? 'Processing...'
          : paymentMethod === 'card'
            ? 'Pay with Card'
            : 'Proceed with Crypto'}
      </Button>

    </PaymentContainer>
  );
};

export default PaymentSection;
